export const filter = {
    id:  "",
    name: '',
    start:  "",
    end: '',
    active: '',
    created_at: '',
    updated_at: '',
};
